document.addEventListener('DOMContentLoaded', function () {
    const blockFeaturedPosts = document.querySelectorAll('.block-featured-posts');

    if (blockFeaturedPosts.length === 0) return;

    blockFeaturedPosts.forEach(function (blockFeaturedPosts) {
        setupBlockFeaturedPostsEdgeGrid(blockFeaturedPosts);
    });
});

function setupBlockFeaturedPostsEdgeGrid(blockFeaturedPosts) {
    const blockFeaturedPostsGrid = blockFeaturedPosts.querySelector('.block-featured-posts__grid');

    if (!blockFeaturedPostsGrid) return;

    const setBlockFeaturedPostsGridWidth = function () {
        const blockFeaturedPostsGridRect = blockFeaturedPostsGrid.getBoundingClientRect();
        const blockFeaturedPostsGridContainer = blockFeaturedPostsGrid.parentElement;
        let blockFeaturedPostsGridContainerWidth = blockFeaturedPostsGrid.offsetWidth;
        const blockFeaturedPostsGridWidth = window.innerWidth - blockFeaturedPostsGridRect.left;

        if (blockFeaturedPostsGridContainer) {
            const blockFeaturedPostsGridContainerStyles = window.getComputedStyle(blockFeaturedPostsGridContainer);
            const blockFeaturedPostsGridContainerPadding = parseFloat(blockFeaturedPostsGridContainerStyles.paddingLeft) + parseFloat(blockFeaturedPostsGridContainerStyles.paddingRight);

            blockFeaturedPostsGridContainerWidth = blockFeaturedPostsGridContainer.clientWidth - blockFeaturedPostsGridContainerPadding;
        }

        blockFeaturedPostsGrid.style.setProperty('--featured-posts-grid-container-width', blockFeaturedPostsGridContainerWidth + 'px');
        blockFeaturedPostsGrid.style.setProperty('--featured-posts-grid-edge-width', blockFeaturedPostsGridWidth + 'px');
    };

    setBlockFeaturedPostsGridWidth();
    window.addEventListener('resize', setBlockFeaturedPostsGridWidth, { passive: true });
}
